import styled from "styled-components";
import Title from "./Title";

const StyledSubtitle = styled(Title)`
  font-size: 1.25rem;
  font-weight: 400;
  @media (min-width: 768px) {
    font-size: 2.25rem;
  }
`;
const Subtitle = ({ children }) => {
  return <StyledSubtitle as="h2">{children}</StyledSubtitle>;
};

export default Subtitle;
